import {
  DetailService,
  MultiImageDownloadChecked,
  MultiImageDownloadRepository,
  MultiImageDownloadService
} from '@aipb/gulliver/catalog/data-access';
import { CatalogRouting } from '@aipb/gulliver/catalog/routing';
import { ResolutionModel } from '@aipb/gulliver/dropbox/model';
import { ConfirmDialogService } from '@aipb/shared/dialog';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';
import { ChecklistComponent } from '../checklist/checklist.component';
import { DownloadFormComponent } from '../download-form/download-form.component';
import { ImageDetailComponent } from '../image-detail/image-detail.component';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { DownloadProgressDialogService } from '../../dialogs/download-progress-dialog';

@Component({
  selector: 'cat-multi-image-download',
  templateUrl: './multi-image-download.component.html',
  styleUrls: ['./multi-image-download.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslocoModule,
    MatButtonModule,
    ChecklistComponent,
    ImageDetailComponent,
    DownloadFormComponent
  ]
})
export class MultiImageDownloadComponent {
  private;
  private multiImageDownloadService = inject(MultiImageDownloadService);
  private multiImageDownloadRepository = inject(MultiImageDownloadRepository);
  public resolutions$ = this.multiImageDownloadRepository.resolutions$;
  public selected$: Observable<MultiImageDownloadChecked> = this.multiImageDownloadRepository.selected$;
  public checked$ = this.multiImageDownloadRepository.checked$;
  public countChecked$ = this.multiImageDownloadRepository.countChecked$;
  public maxBatchSize$ = this.multiImageDownloadRepository.maxBatchSize$;
  public downloadInProgress$ = this.multiImageDownloadRepository.downloadInProgress$;
  private detail = inject(DetailService);
  private catalogRouting = inject(CatalogRouting);
  private confirmDialog = inject(ConfirmDialogService);
  private downloadProgressDialog = inject(DownloadProgressDialogService);

  onDetail(data: MultiImageDownloadChecked): void {
    this.detail.addTab(
      {
        image: data.image,
        id: data.id,
        type: data.type,
        title: data.title,
        query: '*:*'
      },
      true
    );
    this.catalogRouting.detailDefault();
  }

  onDownload(data: [ResolutionModel, string]) {
    this.multiImageDownloadRepository.downloadInProgress = true;
    this.downloadProgressDialog
      .open$({
        resolution: data[0],
        name: data[1],
        count: this.multiImageDownloadRepository.countChecked
      })
      .subscribe(() => {
        this.multiImageDownloadRepository.downloadInProgress = false;
      });
  }

  onUncheck(data: MultiImageDownloadChecked): void {
    this.multiImageDownloadRepository.uncheck(data);
  }

  onClose(): void {
    this.multiImageDownloadService.close();
  }

  onSelect(data: MultiImageDownloadChecked): void {
    this.multiImageDownloadService.select(data);
  }

  onCancelSelection(): void {
    this.confirmDialog
      .open$({
        title: 'catalog.multi_image_download.confirm_cancel_selection'
      })
      .subscribe((confirmed) => {
        if (!confirmed) return;

        this.multiImageDownloadRepository.cancelSelection();
      });
  }
}
